const state = {
    showModal: false, // 是否显示模态框
    isFloating: false, // 是否为悬浮展示
};

const mutations = {
    SET_MODAL_STATE(state, status) {
        state.showModal = status;
    },
    SET_MODAL_FLOATING(state, status) {
        state.isFloating = status;
    },
};

const actions = {
    openModal({ commit }) {
        commit('SET_MODAL_STATE', true);
    },
    closeModal({ commit }) {
        commit('SET_MODAL_STATE', false);

    },
    openFloatingModal({ commit }) {
        commit('SET_MODAL_STATE', true);
        commit('SET_MODAL_FLOATING', true); // 设置为悬浮模式
    },
    closeFloatingModal({ commit }) {
        commit('SET_MODAL_STATE', false);
        commit('SET_MODAL_FLOATING', false); // 关闭悬浮模式
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};